import {
    AutocompleteInput,
    NumberInput,
    required,
    ReferenceInput,
} from 'react-admin';
import { SimpleForm } from '@components/SimpleForm';
import { format } from '@helpers/numeric.ext';
import { Grid } from '@mui/material';

export const PriceForm = () => {
    return (
        <SimpleForm>
            <Grid container spacing={2}>
                <Grid item xs={12} md={12}>
                    <ReferenceInput
                        source="goodsId"
                        reference="goods"
                        perPage={20}
                    >
                        <AutocompleteInput
                            optionText="name"
                            validate={[required()]}
                        />
                    </ReferenceInput>
                </Grid>
                <Grid item xs={12} md={4}>
                    <NumberInput
                        source="minimumOrder"
                        validate={[required()]}
                        format={format}
                    />
                </Grid>
                <Grid item xs={12} md={8}>
                    <NumberInput
                        source="price"
                        validate={[required()]}
                        format={format}
                    />
                </Grid>
            </Grid>
        </SimpleForm>
    );
};
